module.exports = __webpack_public_path__ + "static/media/1-mai-2.e40c2108.jpg";